<template lang="pug">
  selection-base(
    :value="value"
    :items="items"
    item-value="id"
    item-text="name"
    :label="$t('status')"
    :placeholder="$t('placeholder.select-status-power-ball')"
    @input="$emit('input', $event)"
  )
</template>
<script>
import SelectionBase from './SelectionBase.vue'
export default {
  components: {
    SelectionBase
  },
  props: {
    value: {
      type: [String,Object, Number],
      default: null
    },
    label: {
      type: String,
      default: null
    }
  },
  computed: {
    items () {
      return  [
        { name: this.$t('power-ball.status.game-progress'), id: 1 },
        { name: this.$t('power-ball.status.game-over'), id: 0 },
      ]
    }
  }
}
</script>